var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 89C176 137.049 137.049 176 89 176C40.9512 176 2 137.049 2 89C2 40.9512 40.9512 2 89 2C137.049 2 176 40.9512 176 89Z",
    stroke: "url(#paint0_linear_229_1522)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_229_1522",
    x1: 89,
    y1: 0,
    x2: 89,
    y2: 178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEAE0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#FEEAE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECBB2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleShape);
export default __webpack_public_path__ + "static/media/circle-shape.6746065a8cfe532d74593b9f829ace05.svg";
export { ForwardRef as ReactComponent };